import { render, staticRenderFns } from "./GeoPointField.vue?vue&type=template&id=96318444&scoped=true&"
import script from "./GeoPointField.vue?vue&type=script&lang=js&"
export * from "./GeoPointField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96318444",
  null
  
)

export default component.exports
import {QInput,QBtn,QTooltip,QDialog,QCard,QCardSection,QIcon,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign({QInput,QBtn,QTooltip,QDialog,QCard,QCardSection,QIcon,QSeparator,QCardActions}, component.options.components || {})
